import { render } from "./need.vue?vue&type=template&id=a8ab244c&scoped=true"
import script from "./need.vue?vue&type=script&lang=js"
export * from "./need.vue?vue&type=script&lang=js"

import "./need.vue?vue&type=style&index=0&id=a8ab244c&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ab244c"]])

export default __exports__